import { resolveSchoolDashboardPath } from '../school/resolveSchoolDashboardTarget';

/** Where to land after impersonation starts, based on target role. */
export async function resolveImpersonationRedirect(role, accessToken) {
  const normalized = role?.toLowerCase();

  if (normalized === 'parent') {
    return '/app/parent-dashboard';
  }

  if (normalized === 'school' || normalized === 'teacher') {
    return resolveSchoolDashboardPath(accessToken, normalized);
  }

  return '/app';
}
